// extracted by mini-css-extract-plugin
module.exports = {"treebankContainer":"EmbeddedTreebank_treebankContainer__2X6pS","links":"EmbeddedTreebank_links__1ndYN"};